import React from "react";

import { Linking } from "react-native";
import SVGIconButton from "../../shared/designSystem/Buttons/SVGIconButton";
import { IcPrint } from "../../shared/utils/Icons";
import AppTheme from "../../shared/utils/Theme";
import NavBarButton from "../../shared/components/NavBar/NavBarButton";

interface PrintButtonProps {
    title?: string;
    color?: string;
    htmlToPrint: string;
    pdfToShare?: string;
    remotePdfToShare?: string;
}

const PrintButton = (props: PrintButtonProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { color = appTheme.darkBlue, htmlToPrint, pdfToShare, remotePdfToShare } = props;

    const openFile = () => {
        if (htmlToPrint !== undefined) {
            const printWindow = window.open('', '_blank', 'popup');
            let htmlWithJS: string = htmlToPrint.replace("<head>", '<head><script type="text/javascript">document.addEventListener("DOMContentLoaded", (event) => {window.print();window.onafterprint = window.close;});</script>');
            //printWindow?.document.open(htmlWithJS);
            printWindow?.document.writeln(htmlWithJS);
            printWindow?.document.close();
        } else if (pdfToShare !== undefined) {
            Linking.openURL(pdfToShare);
        } else if (remotePdfToShare !== undefined) {
            Linking.openURL(remotePdfToShare);
        }
    }

    return <NavBarButton
        action={openFile}
        icon={IcPrint} />
}

export default PrintButton;